import { Fragment } from "react";
import {
    CashierStepDividerRectangleStyled,
    CashierStepDividerStyled,
    CashierStepsStyled
} from "./styled/CashierStepStyled";
import CashierStep from "./CashierStep";
import { useLangContext } from "../../../../providers/LangProvider/LangProviderContext";

function CashierSteps(props) {
    const {steps, selectedPayment} = props;
    const {getLangPath} = useLangContext();

    return <CashierStepsStyled>
        {
            steps.map((step, index) => <Fragment key={step.title}>
                {index !== 0 && <CashierStepDividerStyled>
                    <CashierStepDividerRectangleStyled/>
                </CashierStepDividerStyled>}
                <CashierStep
                    description={!!step.description ? getLangPath(step.description) : undefined}
                    status={step.status}
                    title={getLangPath(step.title, {payment_name: selectedPayment?.label})}
                />
            </Fragment>)
        }
    </CashierStepsStyled>
}

export default CashierSteps;
